module.exports = __webpack_public_path__ + "assets/img/1.19313d81.png";